/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Header_TitleInputs */

const en_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomous Architecture & Core Systems`)
};

const ar_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية ذاتية القيادة وأنظمة أساسية`)
};

const bn_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোনোমাস আর্কিটেকচার ও কোর সিস্টেম`)
};

const de_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonome Architektur und Kernsysteme`)
};

const es_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura autónoma y sistemas centrales`)
};

const fr_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture autonome et systèmes de base`)
};

const pt_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura Autônoma e Sistemas Centrais`)
};

const zh_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自主架构和核心系统`)
};

const tr_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otonom Mimari ve Çekirdek Sistemler`)
};

const ru_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автономная архитектура и основные системы`)
};

const pl_svc_header_title = /** @type {(inputs: Svc_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektura autonomiczna i systemy podstawowe`)
};

/**
* | output |
* | --- |
* | "Autonomous Architecture & Core Systems" |
*
* @param {Svc_Header_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_header_title = /** @type {((inputs?: Svc_Header_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Header_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_header_title(inputs)
	if (locale === "bn") return bn_svc_header_title(inputs)
	if (locale === "de") return de_svc_header_title(inputs)
	if (locale === "es") return es_svc_header_title(inputs)
	if (locale === "fr") return fr_svc_header_title(inputs)
	if (locale === "pt") return pt_svc_header_title(inputs)
	if (locale === "zh") return zh_svc_header_title(inputs)
	if (locale === "tr") return tr_svc_header_title(inputs)
	if (locale === "ru") return ru_svc_header_title(inputs)
	if (locale === "pl") return pl_svc_header_title(inputs)
	return en_svc_header_title(inputs)
});